import React from 'react';
import PropTypes from 'prop-types';
import { toJS } from 'mobx';
import { get } from 'lodash';
import { observer } from 'mobx-react';
import { browserHistory } from 'react-router';
import StudentChurnTable from './StudentChurnTable';
import { StudentChurnListService } from '../../services/CustomerSuccessKpiListService';

class StudentChurnTableContainer extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['segment', 'distributor']).isRequired,
  };

  constructor(props) {
    super(props);
    StudentChurnListService.load();
  }

  render() {
    return (
      <StudentChurnTable
        loading={StudentChurnListService.fetchCurrent.fetching || StudentChurnListService.fetchPrevious.fetching}
        values={toJS(
          get(StudentChurnListService, { segment: 'bySegment', distributor: 'byDistributor' }[this.props.type], [])
        )}
        feedbackColorRender={StudentChurnListService.getFeedbackColor}
        onSelect={(row) => browserHistory.push(`/kpis/customer-success/${this.props.type}/${row.id}/details`)}
        formatter={StudentChurnListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentChurnTableContainer);
